import { FC, memo } from 'react';
import { StyledCarCondition, StyledDescription, StyledHeader } from './car-condition.styled';

type CarConditionProps = {
    title?: string;
    condition?: string;
    aConditionText?: string;
    bConditionText?: string;
};
const CarCondition: FC<CarConditionProps> = memo(({ title, condition, aConditionText, bConditionText }) => {
    return condition ? (
        <StyledCarCondition>
            <StyledHeader>{title}</StyledHeader>
            <StyledDescription>{condition === 'A' ? aConditionText : bConditionText}</StyledDescription>
        </StyledCarCondition>
    ) : null;
});

export default CarCondition;
